<div class="wrapper mb-5">
    <div class="row align-items-center m-0" style="padding: 10px;">
        <img class="p-2" src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Convites de Gestores</span>
    </div>

    <div class="component-box container-fluid">
        <div class="row container-fluid pt-4">
            <div class="col-12 text-right">
                <ul class="options-cadastro">
                    <li>
                        <div class="list-select mr-4 my-1">
                            <button type="button" class="list-select" (click)="showFilter(filtroconvite)">
                                Aplicar filtro
                            </button>
                        </div>
                    </li>
                    <li>
                        <div class="list-select-search-input ml-2 my-1">
                            <input class="w-100" type="search" placeholder="Pesquise aqui..." #search
                                (change)="searchFilterConvite(search.value)" />
                        </div>
                    </li>
                    <li>
                        <div class="list-filter-show-item ml-2 my-1">
                            Mostrar:
                            <select (change)="showItemChangedInvite($event.target.value)">
                                <option [ngValue]="10" value="10" selected>10</option>
                                <option [ngValue]="25" value="25">25</option>
                                <option [ngValue]="50" value="50">50</option>
                                <option [ngValue]="100" value="100">100</option>
                            </select>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

    <div class="table-overflow mx-2">
        <table class="list-table table table-striped">
            <thead class="list-table-head">
                <th class="" (click)="sortOrder = !sortOrder; orderNomeConvite(gestorConvitesList, sortOrder)">
                    Nome
                </th>
                <th class="" (click)="sortOrder = !sortOrder; orderCPFConvite(gestorConvitesList, sortOrder)">
                    CPF
                </th>
                <th class="" (click)="sortOrder = !sortOrder; orderEmailConvite(gestorConvitesList, sortOrder)">
                    E-mail
                </th>
                <th class="" (click)="sortOrder = !sortOrder; orderStatusConvite(gestorConvitesList, sortOrder)">
                    Status
                </th>
                <th class="" (click)="sortOrder = !sortOrder; orderValidadeConvite(gestorConvitesList, sortOrder)">
                    Validade
                </th>
                <th></th>
            </thead>
            <tbody>
                <tr *ngFor="let item of gestorConvitesList | paginate
                        : {
                            id: 'pagination2',
                            itemsPerPage: showItemInvite,
                            currentPage: currentPageInvite,
                            totalItems: totalItemsInvite
                        }" class=" list-table-cell">
                    <td class="clickable" (click)="item.toBlock = !item.toBlock; updateBlockCount()">
                        {{ item.nome }}
                    </td>
                    <td class="clickable" (click)="item.toBlock = !item.toBlock; updateBlockCount()">
                        {{ item.cpf.toString() | cpf }}
                    </td>
                    <td class="clickable" (click)="item.toBlock = !item.toBlock; updateBlockCount()">
                        {{ item.email }}
                    </td>
                    <td class="clickable" (click)="item.toBlock = !item.toBlock; updateBlockCount()">
                        {{ item.situacaoConviteGestorDescricao }}
                    </td>
                    <td class="clickable" (click)="item.toBlock = !item.toBlock; updateBlockCount()">
                        {{ item.dataValidade.toString() | date: "dd/MM/yyyy HH:mm" }}
                    </td>
                    <td>
                        <div ngbDropdown class="d-inline-block menu-option" *ngIf="showContextMenu &&  (item.situacaoConviteGestorId === SituacaoGestorConvite.EmEdicao || item.situacaoConviteGestorId === SituacaoGestorConvite.Enviado)">
                            <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                <img src="assets/icons/menu.png" />
                            </button>
                            <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                <section class="custom-context-menu">
                                    <div ngbDropdownItem (click)="showCancelarConvite(cancelarconvitemodal,item)">
                                        <img src="assets/icons/garbage-purple.png" class="mr-2" /> Cancelar convite
                                    </div>
                                </section>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="page-custom mt-2">
            <pagination-controls id="pagination2" (pageChange)="changePageInvite($event)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
        </div>
    </div>
</div>
</div>


<!--Modal do Cancelar Convite-->
<ng-template #cancelarconvitemodal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Cancelar Convite</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <div class="col-12 custom-modal-title my-5 text-center">
            <p class="col-12 clean-modal-subtitle" style="font-size: 20px;">
                Tem certeza que deseja cancelar o convite de nome: <span style="color: #313840; font-weight: bold;">{{ gestorConviteToCancel.nome }}?</span>
            </p>
            <ul style="list-style: none;">
                <li class="clean-modal-subtitle" style="color:#313840">CPF: {{ gestorConviteToCancel.cpf | cpf }}</li>
                <li class="clean-modal-subtitle" style="color:#313840">E-mail: {{ gestorConviteToCancel.email }} </li>
            </ul>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" type="button" (click)=" modal.dismiss('Close click')">
            Não
        </button>
        <button class="custom-filter-button custom-filter-button-just" type="button" (click)=" cancelarconvite(gestorConviteToCancel); modal.dismiss('Close click')">
            Cancelar
        </button>
    </div>
</ng-template>


<ng-template #filtroconvite let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Aplicar Filtro</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <div class="col-lg-12 col-md-12 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <label class="clean-filter-label" for="nomeConvite">Nome:</label>
                <input #nomeConvite class="clean-filter-input" type="text" value="{{ filtroNomeConvite }}" />
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <label class="clean-filter-label" for="cpfConvite">CPF:</label>
                <input #cpfConvite class="clean-filter-input" type="text" value="{{ filtroCPFConvite }}" />
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <label class="clean-filter-label" for="emailConvite">E-mail:</label>
                <input #emailConvite class="clean-filter-input" type="text" value="{{ filtroEmailConvite }}" />
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <label class="clean-filter-label" for="statusConvite">Status:</label>
                <input #statusConvite class="clean-filter-input" type="text" value="{{ filtroStatusConvite }}" />
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <!--<input #validadeConvite class="custom-filter-input" type="text"
                    value="{{  (filtroValidadeConvite !== null) ? (filtroValidadeConvite | date: 'dd/MM/yyyy') : '' }}" />-->
                <label style="font-weight: bold; font-size: .8rem; color: #fff;" for="validadeConvite">Validade:</label>
                <my-date-picker id="validadeConvite" class="clean-filter-input" type="date" [options]="myDatePickerOptions" [(ngModel)]="validadeConvite" [maxlength]="10"></my-date-picker>
            </div>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button"
            (click)=" applyFilterConvite(nomeConvite.value, cpfConvite.value, emailConvite.value, statusConvite.value, validadeConvite); modal.dismiss('Close click')">
            Aplicar
        </button>
    </div>
</ng-template>
